import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import UploadPage from "./pages/UploadPage";
import ValidationPage from "./pages/ValidationPage";
import ErrorCorrectionPage from "./pages/ErrorCorrectionPage";
import ThnksSelectionPage from "./pages/ThnksSelectionPage";
import ResultsPage from "./pages/ResultsPage";
import RequestToken from "./utils/requestToken";

/**
 * The `App` component serves as the main entry point for the application.
 * It defines the routing structure and manages state for the application,
 * including `jobId` and `validationData`. Different pages of the application
 * are conditionally rendered based on the current route and state values.
 *
 * @return {JSX.Element} The main application component with routing configuration.
 */
function App() {
  const [jobId, setJobId] = useState(null);
  const [validationData, setValidationData] = useState(null);

  useEffect(() => {
    RequestToken.sendRequest();
  }, []);

  return (
    <div className="app app-iframe">
      <main className="main-content">
        <div className="container">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/upload"
              element={<UploadPage setJobId={setJobId} />}
            />
            <Route
              path="/validation"
              element={
                jobId ? (
                  <ValidationPage
                    jobId={jobId}
                    setValidationData={setValidationData}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/errors"
              element={
                validationData ? (
                  <ErrorCorrectionPage
                    jobId={jobId}
                    validationData={validationData}
                    setValidationData={setValidationData}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/select-thnks"
              element={
                jobId && validationData ? (
                  <ThnksSelectionPage
                    jobId={jobId}
                    validationData={validationData}
                    setValidationData={setValidationData}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/results"
              element={
                jobId ? (
                  <ResultsPage jobId={jobId} validationData={validationData} />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
          </Routes>
        </div>
      </main>
    </div>
  );
}

export default App;
